import React from 'react';
import styled from 'styled-components';
import { card, Header2SemiBold, FlexColumn } from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';

const Wrapper = styled(FlexColumn)`
  ${card};
  flex: 1;
`;

const Title = styled(Header2SemiBold)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
  padding: 10px 20px;
  ${media.tablet`padding: 20px 40px;`}
`;

const Content = styled(FlexColumn)`
  padding: 10px 20px;
  ${media.tablet`padding: 20px 40px;`}
  flex: 1;
`;

const Box = ({ title, children, className }) => (
  <Wrapper className={className}>
    {title && <Title>{title}</Title>}

    <Content>{children}</Content>
  </Wrapper>
);

export default Box;
